export default __webpack_public_path__ + "static/warning-messages-confirm-dont-d65004dcafff85738f7d8bcc088e6818.png";